import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { login } = useAuth();

  const [form, setForm]     = useState({ email: '', password: '', businessId: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || '/';

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(form.email, form.password, form.businessId);
      if (data.firstLogin) {
        navigate('/change-password', { replace: true });
      } else {
        navigate(from, { replace: true });
      }
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.logo}>Aetheris</h1>
        <p style={styles.sub}>Sign in to your account</p>

        {location.state?.message && (
          <div style={styles.success}>{location.state.message}</div>
        )}
        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            style={styles.input}
            name="email"
            type="email"
            placeholder="Email address"
            value={form.email}
            onChange={change}
            required
          />
          <input
            style={styles.input}
            name="businessId"
            type="text"
            placeholder="Business Name"
            value={form.businessId}
            onChange={change}
            required
          />
          <input
            style={styles.input}
            name="password"
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={change}
            required
          />
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={styles.link}>
          Have an invite code?{' '}
          <span style={styles.a} onClick={() => navigate('/activate')}>
            Activate your account
          </span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    background: 'rgba(15, 23, 42, 0.95)',
    border: '1px solid rgba(59, 130, 246, 0.2)',
    borderRadius: '16px',
    padding: '48px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
  },
  logo: {
    fontSize: '32px',
    fontWeight: 'bold',
    color: '#6C63FF',
    textAlign: 'center',
    marginBottom: '8px',
    textShadow: '0 0 20px rgba(108,99,255,0.5)',
  },
  sub: {
    color: '#94a3b8',
    textAlign: 'center',
    marginBottom: '32px',
    fontSize: '14px',
  },
  form:  { display: 'flex', flexDirection: 'column', gap: '16px' },
  input: {
    padding: '12px 16px',
    background: 'rgba(30, 41, 59, 0.8)',
    border: '1px solid rgba(59, 130, 246, 0.2)',
    borderRadius: '8px',
    color: '#e2e8f0',
    fontSize: '14px',
    outline: 'none',
  },
  btn: {
    padding: '14px',
    background: 'linear-gradient(135deg, #6C63FF, #3b82f6)',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
  },
  error:   { background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '12px', color: '#f87171', fontSize: '14px', marginBottom: '8px' },
  success: { background: 'rgba(34,197,94,0.15)', border: '1px solid rgba(34,197,94,0.3)',  borderRadius: '8px', padding: '12px', color: '#4ade80', fontSize: '14px', marginBottom: '8px' },
  link:    { color: '#64748b', fontSize: '13px', textAlign: 'center', marginTop: '24px' },
  a:       { color: '#6C63FF', cursor: 'pointer', textDecoration: 'underline' },
};
